import './rateCard.css';
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import Table from 'react-bootstrap/Table';
import { getItemTypeList, getUrnsList, getAllRouteDetails, getRateUnits, rateCardValidity, fetchBudgetApprovalRole, getCategoryUrnList, getGrowerUrnsList } from './rateCardAPIs';
import { getAllState, getAllDistrict, getAllRevenueCircle, getCategoryList } from '../resourceCommonAPIs';
import { CATEGORY_ERROR, ITEM_TYPE_ERROR, STATE_ERROR, DISTRICT_ERROR, REVENUE_CIRCLE_ERROR, ROUTE_TYPE_ERROR, UNIT_PER_ERROR, CREATE_RATE_CARD, STAKEHOLDER_URN, STAKEHOLDER_NAME, REGISTRATION_NO, VEHICLE_TYPE, VEHICLE_CAPACITY, VEHICLE_MAKE, VEHICLE_MODEL, ROUTE, LAND_NAME, ITEM_RATE, SUBMIT, CATEGORY, ITEM_TYPE, ROUTE_TYPE, STATE, DISTRICT, REVENUE_CIRCLE, UNIT_PER, ITEM_RATE_MASS_ENTRY, INSERT_ALL, NO_DATA_AVAILABLE, PROCEED, INSERT_SELECTED } from '../../../common/constants';
import { handleNumberFieldFocus, titleCase } from '../../../common/commonFunction';
import { Autocomplete, Button, CardContent } from '@mui/material';
import { ErrorPopover } from "../../../common/ErrorPopover/errorPopover";
import { PROD } from '../../../common/constants';
import { Container, Card, Stack, Box, Typography, Grid, FormHelperText, FormControl, InputLabel, Select, MenuItem, TextField } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { DataGrid } from '@mui/x-data-grid';
import CustomDataGridToolbar from '../../../common/customDataGridToolbar';
import BackButton from '../../../common/backButton';
import { DistrictChangePopover } from './districtChangePopover';
import { validateAmount } from '../../../common/commonValidations';
import { v4 as uuidv4 } from 'uuid';
import { toast } from 'react-toastify';
import { AddIcon, ProceedIcon } from '../../../common/icons';

function GrowerLleRateCard() {
    const navigate = useNavigate();
    const { state } = useLocation();
    const [categoryList, setCategoryList] = useState();
    const [itemTypeList, setItemTypeList] = useState();
    const [showData, setShowData] = useState(state?.category ? true : false);
    const [onChangeFlag, setOnChangeFlag] = useState(false);
    const [urnsList, setUrnsList] = useState(state?.urnsList && state?.urnsList);
    const [routesList, setRoutesList] = useState();
    const [chooseState, setchooseState] = useState([]);
    const [chooseDistrict, setChooseDistrict] = useState([]);
    const [chooseRevenueCircle, setChooseRevenueCircle] = useState([]);
    const [unitsList, setUnitsList] = useState([]);
    const [checkValidityResponse, setCheckValidityResponse] = useState();
    const [failedRateCardArr, setFailedRateCardArr] = useState();
    const [logModalOpen, setLogModalOpen] = useState(false);
    const handleLogModalOpen = () => setLogModalOpen(true);
    const handleLogModalClose = () => setLogModalOpen(false);
    const [distrcitLogModalOpen, setDistrcitLogModalOpen] = useState(false);
    const handleDistrictLogModalOpen = () => setDistrcitLogModalOpen(true);
    const handleDistrictLogModalClose = () => setDistrcitLogModalOpen(false);
    const [budgetApprovalRole, setBudgetApprovalRole] = useState();
    const [llePlantList, setLlePlantList] = useState([]);
    const [selectedUrn, setSelectedUrn] = useState('');
    const [mappedWith, setMappedWith] = useState('');

    const [rateCardDetails, setRateCardDetails] = useState(
        {
            category: "Grower",
            itemType: "Bamboo Rate",
            unitPer: state?.unitPer ? state?.unitPer : null,
            // validFromProceed: state?.validFromProceed ? state?.validFromProceed : null,
            // validToProceed: state?.validToProceed ? state?.validToProceed : null,
            validFrom: state?.validFrom ? state?.validFrom : null,
            validTo: state?.validTo ? state?.validTo : null,
            itemRate: state?.itemRate ? state?.itemRate : null,
            routeType: state?.routeType ? state?.routeType : null,
            state: state?.state ? state?.state : null,
            district: state?.district ? state?.district : null,
            revenueCircle: state?.revenueCircle ? state?.revenueCircle : null,
        }
    );
    const [errorMessage, setErrorMessage] = useState({
        categoryError: '',
        selectedUrnError: '',
        itemTypeError: '',
        unitPerError: '',
        itemRateError: '',
        validFromError: '',
        validToError: '',
        // validFromProceedError: '',
        // validToProceedError: '',
        routeTypeError: '',
        stateError: '',
        districtError: '',
        addItemError: '',
        mappedWithError: ''
    });
    const [rateCardDetailsArr, setRateCardDetailsArr] = useState(state?.rateCardDetailsArr ? state?.rateCardDetailsArr : []);
    const [finalRateCardDetailsArr, setFinalRateCardDetailsArr] = useState(state?.finalRateCardDetailsArr && state?.finalRateCardDetailsArr);
    const [addedRateCardDetailsArr, setAddedRateCardDetailsArr] = useState(state?.addedRateCardDetailsArr ? state?.addedRateCardDetailsArr : []);
    const [filteredRateCardDetailsArr, setFilteredRateCardDetailsArr] = useState();
    const [filterTable, setFilterTable] = useState({
        urnNumber: '',
        name: ''
    });
    const [submit, setSubmit] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);

    useEffect(() => {
        if (!mappedWith) return;

        if (mappedWith === "Plant") {
            setSelectedUrn("Plant");
            setLlePlantList([]);
        } else {
            getCategoryUrnList(mappedWith, setLlePlantList);
        }

    }, [mappedWith]);

    useEffect(() => {
        getRateUnits(setUnitsList);
    }, []);

    useEffect(() => {
        if (urnsList) {
            let arrayData = []
            urnsList?.map((item) => {
                if (rateCardDetails?.category) {
                    item?.landDtlList?.map((landDtlList) => arrayData.push({
                        id: uuidv4(),
                        category: "Grower",
                        growerType: item?.category,
                        itemType: "Bamboo Rate",
                        unitPer: rateCardDetails?.unitPer,
                        urnNumber: item?.urn,
                        name: item?.name,
                        state: landDtlList?.state,
                        district: landDtlList?.district,
                        revenueCircle: landDtlList?.revenueCircle,
                        toName: item?.toName,
                        toUrn: item?.toUrn,
                        vehicleId: null,
                        registrationNo: null,
                        vehicleType: null,
                        vehicleCapacity: null,
                        vehicleMake: null,
                        vehicleModel: null,
                        vehicleMakeModel: null,
                        routeName: null,
                        transporterTableId: null,
                        route: null,
                        routeUrn: null,
                        landId: landDtlList?.landId,
                        landName: landDtlList?.landName,
                        landType: landDtlList?.landType,
                        itemRate: landDtlList?.bambooRate,
                        validFrom: landDtlList?.validFrom,
                        validTo: landDtlList?.validTo,
                        toState: landDtlList?.toState,
                        toDistrict: landDtlList?.toDistrict,
                        background: null,
                        justification: null,
                        finalSummary: null,
                        documentName: null,
                        documentGuid: null,
                    }))
                }
            }
            )
            setRateCardDetailsArr(arrayData);
        }
    }, [urnsList]);

    const onProceedViewRateCardTable = (e) => {
        e.preventDefault();
        if (!mappedWith) {
            setErrorMessage({ ...errorMessage, mappedWithError: "Please select Mapped with value" });
        }
        else if (mappedWith === "LLE" && !selectedUrn) {
            setErrorMessage({ ...errorMessage, selectedUrnError: "Please select URN" });
        }
        else {
            getGrowerUrnsList(setUrnsList, selectedUrn);
            setShowData(true);
        }
    }

    const onInsertItemRate = (e) => {
        setRateCardDetailsArr((prevRows) => prevRows?.map(rateCardDetailsArrItem => selectedRows?.includes(rateCardDetailsArrItem?.id) ? {
            ...rateCardDetailsArrItem,
            itemRate: rateCardDetails?.itemRate,
            validFrom: rateCardDetails?.validFrom,
            validTo: rateCardDetails?.validTo,
        } : rateCardDetailsArrItem))
        setFailedRateCardArr();
    }

    const handleEachChange = (e, item, type) => {
        setOnChangeFlag(true);
        const tempArr = ((rateCardDetailsArr).map(rateCardDetailsArrItem => {
            if (rateCardDetailsArrItem.urnNumber === item.urnNumber && rateCardDetailsArrItem.vehicleId === item.vehicleId && rateCardDetailsArrItem.transporterTableId === item.transporterTableId && rateCardDetailsArrItem.landId === item.landId) {
                if (type === "itemRateEach") {
                    const validatedAmount = validateAmount(e.target.value);
                    if (e.target.value === '') {
                        rateCardDetailsArrItem.itemRate = ''
                    }
                    if (validatedAmount) {
                        rateCardDetailsArrItem.itemRate = validatedAmount
                    }
                }
                if (type === "validFromEach") {
                    const tempArr = failedRateCardArr && failedRateCardArr?.filter(filterItem => filterItem !== item)
                    setFailedRateCardArr(tempArr);
                    rateCardDetailsArrItem.validFrom = e.format("YYYY-MM-DD")
                }
                if (type === "validToEach") {
                    const tempArr = failedRateCardArr && failedRateCardArr?.filter(filterItem => filterItem !== item)
                    setFailedRateCardArr(tempArr);
                    rateCardDetailsArrItem.validTo = e.format("YYYY-MM-DD")
                }
            }
            return rateCardDetailsArrItem
        }
        ))
        setRateCardDetailsArr(tempArr);
    }

    const [tempDistrict, setTempDistrict] = useState("")

    const handleChange = (e, item) => {
        setOnChangeFlag(true);
        // if (e.target.name === "category") {
        //     setRateCardDetails({ ...rateCardDetails, category: e.target.value })
        //     setSelectedUrn('');
        //     setErrorMessage({ ...errorMessage, categoryError: "" });
        // }
        if (e.target.name === "unitPer") {
            setRateCardDetails({ ...rateCardDetails, unitPer: e.target.value })
            setErrorMessage({ ...errorMessage, unitPerError: "" });
        }
        if (e.target.name === "itemRate") {
            const validatedAmount = validateAmount(e.target.value);
            if (e.target.value === '') {
                setRateCardDetails({ ...rateCardDetails, itemRate: '' })
            }
            if (validatedAmount) {
                setRateCardDetails({ ...rateCardDetails, itemRate: validatedAmount })
            }
        }
        if (e.target.name === "validFrom") {
            setRateCardDetails({ ...rateCardDetails, validFrom: e.target.value })
        }
        if (e.target.name === "validTo") {
            setRateCardDetails({ ...rateCardDetails, validTo: e.target.value })
        }
        if (item) {
            const tempArr = ((rateCardDetailsArr).map(rateCardDetailsArrItem => {
                if (rateCardDetailsArrItem.urnNumber === item.urnNumber && rateCardDetailsArrItem.vehicleId === item.vehicleId && rateCardDetailsArrItem.transporterTableId === item.transporterTableId && rateCardDetailsArrItem.landId === item.landId) {
                    if (e.target.name === "itemRateEach") {
                        rateCardDetailsArrItem.itemRate = e.target.value
                    }
                    if (e.target.name === "validFromEach") {
                        const tempArr = failedRateCardArr && failedRateCardArr?.filter(filterItem => filterItem !== item)
                        setFailedRateCardArr(tempArr);
                        rateCardDetailsArrItem.validFrom = e.target.value
                    }
                    if (e.target.name === "validToEach") {
                        const tempArr = failedRateCardArr && failedRateCardArr?.filter(filterItem => filterItem !== item)
                        setFailedRateCardArr(tempArr);
                        rateCardDetailsArrItem.validTo = e.target.value
                    }
                }
                return rateCardDetailsArrItem
            }
            ))
            setRateCardDetailsArr(tempArr);
        }
    }

    useEffect(() => {
        if (onChangeFlag) {
            let arrayData = [];
            rateCardDetailsArr?.map((item) =>
                item.itemRate && arrayData.push(item)
            )
            setFinalRateCardDetailsArr(arrayData);
        }
    }, [rateCardDetailsArr]);

    useEffect(() => {
        if (onChangeFlag) {
            setRateCardDetails({
                ...rateCardDetails,
                itemType: null,
                itemRate: null,
                // validFromProceed: null,
                // validToProceed: null,
                validFrom: null,
                validTo: null,
                unitPer: null,
                routeType: null,
                state: null,
                district: null,
                revenueCircle: null
            });
            setRateCardDetailsArr([]);
            setShowData(false);
            setUrnsList();
            setChooseDistrict([]);
        }
    }, [rateCardDetails.category]);

    useEffect(() => {
        if (onChangeFlag) {
            setRateCardDetails({
                ...rateCardDetails,
                itemRate: null,
                validFrom: null,
                validTo: null,
            });
            setRateCardDetailsArr([]);
            setShowData(false);
            setUrnsList();
        }
    }, [rateCardDetails.itemType, rateCardDetails.routeType, rateCardDetails.revenueCircle]);

    useEffect(() => {
        if (onChangeFlag) {
            setRateCardDetails({
                ...rateCardDetails,
                itemRate: null,
                validFrom: null,
                validTo: null,
                district: null,
                revenueCircle: null
            });
            setShowData(false);
            setUrnsList();
        }
    }, [rateCardDetails.state]);

    useEffect(() => {
        if (onChangeFlag) {
            setRateCardDetails({
                ...rateCardDetails,
                itemRate: null,
                validFrom: null,
                validTo: null,
                revenueCircle: null
            });
            setShowData(false);
            setUrnsList();
        }
    }, [rateCardDetails.district]);

    useEffect(() => {
        if (onChangeFlag) {
            const tempArr = (rateCardDetailsArr?.map(item => {
                if (!addedRateCardDetailsArr?.includes(item)) {
                    item.unitPer = rateCardDetails.unitPer
                }
                return item
            }
            ))
        }
    }, [rateCardDetails?.unitPer]);

    useEffect(() => {
        if (filterTable.urnNumber || filterTable.name) {
            const filteredRateCardDetails = rateCardDetailsArr && rateCardDetailsArr?.filter(
                item => {
                    let keep = true;
                    if (filterTable.urnNumber) {
                        keep = keep && item.urnNumber?.toLowerCase()?.includes(filterTable?.urnNumber.toLowerCase().trim())
                    }
                    if (filterTable.name) {
                        keep = keep && item.name?.toLowerCase()?.includes(filterTable?.name.toLowerCase().trim())
                    }
                    return keep;
                }

            );
            setFilteredRateCardDetailsArr(filteredRateCardDetails);
        }
        else {
            setFilteredRateCardDetailsArr();
        }
    }, [filterTable.urnNumber, filterTable.name]);

    const onNext = (e) => {
        e.preventDefault();
        if (budgetApprovalRole?.budgetApproverFound === false) {
            toast.error("Budget approver role is not found!. Please, add budget approver role based on budget range")
        }
        else (addedRateCardDetailsArr?.length !== 0 && addedRateCardDetailsArr ? navigate('previewRateCard',
            {
                state: {
                    rateCardDetailsArr: rateCardDetailsArr, addedRateCardDetailsArr: addedRateCardDetailsArr,
                    finalRateCardDetailsArr: finalRateCardDetailsArr, urnsList: urnsList, category: rateCardDetails?.category,
                    itemType: "Bamboo Rate", unitPer: rateCardDetails?.unitPer, itemRate: rateCardDetails?.itemRate,
                    validFrom: rateCardDetails?.validFrom, validTo: rateCardDetails?.validTo, state: rateCardDetails?.state,
                    district: rateCardDetails?.district, revenueCircle: rateCardDetails?.revenueCircle, routeType: rateCardDetails?.routeType,
                    budget: budgetApprovalRole
                }
            }) : setErrorMessage({ ...errorMessage, addItemError: "Please add item rate and then proceed" }))
    }

    const onAdd = (e) => {
        e.preventDefault();
        if (!rateCardDetails?.unitPer) {
            setErrorMessage({ ...errorMessage, unitPerError: UNIT_PER_ERROR });
        }
        else if (selectedRows?.length === 0) {
            toast.error("Please select stakeholder add item rate and then proceed")
        }
        else {
            const validityArr = finalRateCardDetailsArr?.filter(item => !addedRateCardDetailsArr?.includes(item))
            const arr = validityArr?.filter(item => selectedRows?.includes(item?.id))
            // console.log("arr", arr)
            // fetchBudgetApprovalRole(setBudgetApprovalRole, validityArr);
            // rateCardValidity(validityArr, setCheckValidityResponse);
            setCheckValidityResponse(arr)
        }
    };
    // useEffect(() => {
    //   if (budgetApprovalRole) {
    //     if (budgetApprovalRole?.budgetApproverFound === false) {
    //       toast.error("Budget approver role is not found! Please add budget approver role based on budget range")
    //     }
    //     // else {
    //     //   const validityArr = finalRateCardDetailsArr?.filter(item => !addedRateCardDetailsArr?.includes(item))
    //     //   rateCardValidity(validityArr, setCheckValidityResponse);
    //     // }
    //   }
    //   // fetchBudgetApprovalRole(setBudgetApprovalRole, addedRateCardDetailsArr);
    // }, [budgetApprovalRole])

    useEffect(() => {
        if (checkValidityResponse) {
            // const successTempArr = [];
            // const failTempArr = [];
            // checkValidityResponse?.map((item) => {
            //   if (item?.respStts?.status === "SUCCESS") {
            //     const pushObject = finalRateCardDetailsArr.find(findItem => findItem?.urnNumber === item?.application?.urnNumber && findItem?.vehicleId === item?.application?.vehicleId && findItem?.transporterTableId === item?.application?.transporterTableId && findItem?.landId === item?.application?.landId);
            //     successTempArr.push(pushObject);
            //   }
            //   else {
            //     const pushObject = finalRateCardDetailsArr.find(findItem => findItem?.urnNumber === item?.application?.urnNumber && findItem?.vehicleId === item?.application?.vehicleId && findItem?.transporterTableId === item?.application?.transporterTableId && findItem?.landId === item?.application?.landId);
            //     failTempArr.push(pushObject);
            //   }
            // });
            // setErrorMessage({ ...errorMessage, addItemError: "" });
            setAddedRateCardDetailsArr([...addedRateCardDetailsArr, ...checkValidityResponse]);
            // setFailedRateCardArr(failTempArr);
            // if (!checkValidityResponse?.every(item => item?.respStts?.status === "SUCCESS")) {
            //   toast.error("Rate card already exists in the given date range for the items marked in red")
            // }
        }
    }, [checkValidityResponse]);


    function onCancelBack() {
        handleDistrictLogModalClose();
    }

    function onConfirmCallBack() {
        handleDistrictLogModalClose();
        getAllRevenueCircle(tempDistrict, setChooseRevenueCircle);
        setRateCardDetails({ ...rateCardDetails, district: tempDistrict })
        setErrorMessage({ ...errorMessage, districtError: "" });
        setAddedRateCardDetailsArr([]);
        setFinalRateCardDetailsArr([]);
    }

    const excelColumns = [
        { field: 'category', headerName: "Category", width: 150 },
        { field: 'itemType', headerName: "Item Type", width: 150 },
        { field: 'urnNumber', headerName: STAKEHOLDER_URN, width: 500 },
        { field: 'name', headerName: STAKEHOLDER_NAME, width: 150 },
        { field: 'unitPer', headerName: "Unit Per", width: 150 },
        {
            field: 'state', headerName: STATE, width: 150, hide: rateCardDetails?.category !== "LLE" && rateCardDetails?.category !== "Grower",
            renderCell: (params) => {
                return (
                    params?.row?.state && titleCase(params?.row?.state)
                )
            }
        },
        {
            field: 'district', headerName: DISTRICT, width: 150, hide: rateCardDetails?.category !== "LLE" && rateCardDetails?.category !== "Grower",
            renderCell: (params) => {
                return (
                    params?.row?.district && titleCase(params?.row?.district)
                )
            }
        },
        // {
        //     field: 'revenueCircle', headerName: REVENUE_CIRCLE, width: 150, hide: rateCardDetails?.category !== "Grower",
        //     renderCell: (params) => {
        //         return (
        //             params?.row?.district && titleCase(params?.row?.district)
        //         )
        //     }
        // },
        { field: 'landName', headerName: LAND_NAME, width: 150, },
        { field: 'landId', headerName: "Land Id", width: 150, },
        {
            field: 'validFrom', headerName: 'Valid From', width: 170,
            renderCell: (params) => {
                return (
                    <>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DesktopDatePicker
                                label="Valid From"
                                inputFormat="DD/MM/YYYY"
                                value={params.row?.validFrom}
                                onChange={(newValue) => handleEachChange(newValue, params.row, "validFromEach")}
                                renderInput={(params) => <TextField {...params}
                                    size="small" />}
                                sx={{ minWidth: 750 }}
                            /></LocalizationProvider>
                    </>
                )
            }
        },
        {
            field: 'validTo', headerName: 'Valid To', width: 170,
            renderCell: (params) => {
                return (
                    <>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DesktopDatePicker
                                label="Valid To"
                                inputFormat="DD/MM/YYYY"
                                minDate={params.row?.validFrom}
                                value={params?.row?.validTo}
                                onChange={(newValue) => handleEachChange(newValue, params.row, "validToEach")}
                                renderInput={(params) => <TextField {...params}
                                    size="small" />}
                                sx={{ minWidth: 750 }}
                            /></LocalizationProvider>
                    </>
                )
            }
        },
        {
            field: 'itemRate', headerName: ITEM_RATE, width: 150,
            renderCell: (params) => {
                return (
                    <TextField fullWidth
                        size="small"
                        label="Item Rate"
                        type="number"
                        onFocus={handleNumberFieldFocus}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '-' || evt.key === '+') && evt.preventDefault()}
                        value={params.row?.itemRate || ''}
                        onChange={(e) => handleEachChange(e, params.row, "itemRateEach")}
                    ></TextField>
                )
            }
        },
        { field: 'background', headerName: "Background", width: 150 },
        { field: 'justification', headerName: "Justification", width: 150 },
        { field: 'finalSummary', headerName: "Final Summary", width: 150 },
    ];

    const columns = [
        { field: 'urnNumber', headerName: STAKEHOLDER_URN, width: 150 },
        { field: 'name', headerName: STAKEHOLDER_NAME, width: 150 },
        {
            field: 'state', headerName: STATE, width: 150,
            renderCell: (params) => {
                return (
                    params?.row?.state && titleCase(params?.row?.state)
                )
            }
        },
        {
            field: 'district', headerName: DISTRICT, width: 150,
            renderCell: (params) => {
                return (
                    params?.row?.district && titleCase(params?.row?.district)
                )
            }
        },
        { field: "toUrn", headerName: "Destination URN", width: 200, },
        { field: "toName", headerName: "Destination Name", width: 200, },
        { field: 'landName', headerName: LAND_NAME, width: 150 },
        {
            field: 'validFrom', headerName: 'Valid From', width: 170,
            renderCell: (params) => {
                // console.log("params", params.row)
                return (
                    <>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DesktopDatePicker
                                label="Valid From"
                                inputFormat="DD/MM/YYYY"
                                value={params.row?.validFrom}
                                onChange={(newValue) => handleEachChange(newValue, params.row, "validFromEach")}
                                renderInput={(params) => <TextField {...params}
                                    size="small" />}
                                sx={{ minWidth: 750 }}
                            /></LocalizationProvider>
                    </>
                )
            }
        },
        {
            field: 'validTo', headerName: 'Valid To', width: 170,
            renderCell: (params) => {
                return (
                    <>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DesktopDatePicker
                                label="Valid To"
                                inputFormat="DD/MM/YYYY"
                                minDate={params.row?.validFrom}
                                value={params?.row?.validTo}
                                onChange={(newValue) => handleEachChange(newValue, params.row, "validToEach")}
                                renderInput={(params) => <TextField {...params}
                                    size="small" />}
                                sx={{ minWidth: 750 }}
                            /></LocalizationProvider>
                    </>
                )
            }
        },
        {
            field: 'itemRate', headerName: ITEM_RATE, width: 150,
            renderCell: (params) => {
                return (
                    <TextField fullWidth
                        size="small"
                        label="Item Rate"
                        type="number"
                        onFocus={handleNumberFieldFocus}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '-' || evt.key === '+') && evt.preventDefault()}
                        value={params.row?.itemRate || ''}
                        onChange={(e) => handleEachChange(e, params.row, "itemRateEach")}
                    ></TextField>
                )
            }
        },
    ];

    const handleCheckboxChange = (selectedRowIds) => {
        setSelectedRows(selectedRowIds)
        setErrorMessage({ ...errorMessage, noSelectedPoError: "" })
    };

    const handleUrnChange = (e, newValue) => {
        setSelectedUrn(newValue ? newValue.urn : null);
        setErrorMessage({ ...errorMessage, selectedUrnError: "" })
    };

    const handleMappedWithChange = (e) => {
        setMappedWith(e.target.value);
        setErrorMessage({ ...errorMessage, mappedWithError: "" });
        setSelectedUrn('');
    }

    return (
        <>
            <Container maxWidth="xxl">
                {!PROD && <p className='pageNumberingResc'>RES16</p>}
                <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                    <BackButton navigate={navigate} />
                    <Typography variant="h5" gutterBottom>
                        Rate Card based on mapped LLE/Plant
                    </Typography>
                </Stack>
                <Card>
                    <CardContent>
                        <Grid container spacing={1}>
                            <Grid item xs={12} lg={4}>
                                <TextField
                                    fullWidth
                                    label={CATEGORY}
                                    value={
                                        rateCardDetails?.category || ''
                                    }
                                    disabled
                                />
                            </Grid>
                            <Grid item xs={12} lg={4}>
                                <FormControl sx={{ width: '100%', paddingRight: '3%' }} error={submit && !rateCardDetails?.category}>
                                    <InputLabel id="selectstakeholder-label">Mapped with</InputLabel>
                                    <Select
                                        label="Mapped with"
                                        name="category" value={mappedWith || ''} onChange={(e) => handleMappedWithChange(e)}>
                                        <MenuItem value={"LLE"}>LLE</MenuItem>
                                        <MenuItem value={"Plant"}>Plant</MenuItem>
                                    </Select>
                                    <FormHelperText sx={{ color: 'red' }}>{errorMessage?.mappedWithError}</FormHelperText>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} lg={4} hidden={rateCardDetails.category === "Plant"}>
                                <Autocomplete
                                    options={llePlantList}
                                    value={llePlantList.find((item) => item.urn === selectedUrn) || null}
                                    onChange={handleUrnChange}
                                    getOptionLabel={(option) => `${option.urn} - ${option.stakeholderName}`}
                                    renderOption={(props, option) => (
                                        <li {...props}>
                                            <strong>{option.urn}</strong> - {option.stakeholderName}
                                        </li>
                                    )}
                                    filterOptions={(options, { inputValue }) =>
                                        options.filter(
                                            (option) =>
                                                option.urn.toLowerCase().includes(inputValue.toLowerCase()) ||
                                                option.stakeholderName.toLowerCase().includes(inputValue.toLowerCase())
                                        )
                                    }
                                    renderInput={(params) => (
                                        <TextField {...params} label="URN" />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12} lg={4}>
                                <TextField
                                    fullWidth
                                    label={ITEM_TYPE}
                                    value={
                                        rateCardDetails?.category
                                            ? 'Bamboo Rate'
                                            : ''
                                    }
                                    disabled
                                />
                            </Grid>
                            <Grid item xs={12} lg={2}>
                                <Button endIcon={<ProceedIcon />} sx={{ minWidth: 100 }} className="RescProceed" variant="contained" onClick={(e) => onProceedViewRateCardTable(e)}>{PROCEED}</Button>
                            </Grid>
                        </Grid>
                        <Grid container spacing={1} sx={{ mt: 1 }}>
                            {showData &&
                                <> <Grid item xs={12} lg={3}>
                                    <FormControl sx={{ width: '100%', paddingRight: '3%' }} error={submit && !rateCardDetails?.unitPer}>
                                        <InputLabel id="selectstakeholder-label">{UNIT_PER}</InputLabel>
                                        <Select
                                            label={UNIT_PER}
                                            name="unitPer" value={rateCardDetails?.unitPer || ''} onChange={(e) => handleChange(e)}>
                                            <MenuItem><em>{UNIT_PER}</em></MenuItem>
                                            {
                                                unitsList?.["unit per"]?.map((unitsList) =>
                                                    <MenuItem value={unitsList}>{unitsList}</MenuItem>)
                                            }
                                        </Select>
                                        <FormHelperText sx={{ color: 'red' }}>{errorMessage?.unitPerError}</FormHelperText>
                                    </FormControl>
                                </Grid>
                                    <Grid item xs={12} lg={2}>
                                        <FormControl sx={{ width: '100%', paddingRight: '3%' }}>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DesktopDatePicker
                                                    label="Valid From"
                                                    inputFormat="DD/MM/YYYY"
                                                    value={rateCardDetails?.validFrom}
                                                    onChange={(validfromValue) => setRateCardDetails({ ...rateCardDetails, validFrom: validfromValue.format("YYYY-MM-DD") })}
                                                    renderInput={(params) => <TextField {...params} />}
                                                    sx={{ minWidth: 750 }}
                                                /></LocalizationProvider>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} lg={2}>
                                        <FormControl sx={{ width: '100%', paddingRight: '3%' }}>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DesktopDatePicker
                                                    label="Valid To"
                                                    inputFormat="DD/MM/YYYY"
                                                    minDate={rateCardDetails?.validFrom}
                                                    value={rateCardDetails?.validTo}
                                                    onChange={(validtoValue) => setRateCardDetails({ ...rateCardDetails, validTo: validtoValue.format("YYYY-MM-DD") })}
                                                    renderInput={(params) => <TextField {...params} />}
                                                    sx={{ minWidth: 750 }}
                                                /></LocalizationProvider>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} lg={2}>
                                        <TextField fullWidth
                                            type="number"
                                            onFocus={handleNumberFieldFocus}
                                            label="Item Rate"
                                            name="itemRate" value={rateCardDetails?.itemRate || ''} onChange={(e) => handleChange(e)}
                                            onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '-' || evt.key === '+') && evt.preventDefault()}
                                            sx={{ paddingRight: '3%' }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} lg={rateCardDetails?.category === "Transporter" ? 1 : 2}>
                                        <div className="resource-common-label-heading">&nbsp;</div>
                                        <p className="insert-button" onClick={(e) => onInsertItemRate(e)}>{INSERT_SELECTED}</p>
                                    </Grid>
                                </>}
                        </Grid>
                        {urnsList && showData ?
                            <Grid container spacing={1} sx={{ mt: 3 }}>
                                <Grid item xs={12} lg={12}>
                                    <DataGrid autoHeight sx={{
                                        height: 430, width: '100%', mt: 2,
                                        '& .themeSuccess': {
                                            backgroundColor: '#FFFFFF'
                                        },
                                        '& .themeFailure': {
                                            backgroundColor: '#FF7F7F',
                                            color: '#1a3e72',
                                        },
                                    }}
                                        rows={(filteredRateCardDetailsArr ? filteredRateCardDetailsArr : rateCardDetailsArr)?.filter(addedItem => !addedRateCardDetailsArr?.includes(addedItem))}
                                        columns={columns}
                                        pageSize={10}
                                        checkboxSelection
                                        onSelectionModelChange={handleCheckboxChange}
                                        getCellClassName={(params) => {
                                            return failedRateCardArr?.includes(params?.row) ? 'themeFailure' : 'themeSuccess';
                                        }}
                                        components={{
                                            Toolbar: CustomDataGridToolbar,
                                        }}
                                        componentsProps={{ toolbar: { rows: rateCardDetailsArr?.filter(addedItem => !addedRateCardDetailsArr?.includes(addedItem)), columns: excelColumns, fileName: "RateCard.xlsx", name: "Download Template" } }}
                                    />
                                </Grid>

                                <div className='resource-common-error-message' >{errorMessage.addItemError}</div>
                            </Grid>
                            :
                            <></>
                        }
                        <Grid item xs={12} lg={12} display='flex' justifyContent="flex-end">
                            {urnsList && showData &&
                                <><Button endIcon={<ProceedIcon />} sx={{ minWidth: 100, mt: 2 }} variant="contained" onClick={(e) => onNext(e)} >Next</Button>
                                    <Button endIcon={<startIcon />} sx={{ minWidth: 100, mt: 2, ml: 2 }} variant="contained" value='add' onClick={(e) => onAdd(e)}>Add</Button></>
                            }
                        </Grid>
                    </CardContent>
                </Card>
            </Container>
        </>
    );
}
export default GrowerLleRateCard;
